import * as React from "react";

import { cn } from "@garther/ui/libs";

export * from "./select";
export * from "./quantity-input";
export * from "./textarea";
export * from "./ckeditor";
export * from "./image-input";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  required?: boolean;
  labelClassName?: string;
  error?: string;
  containerClassName?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type,
      label,
      labelClassName,
      required,
      error,
      containerClassName,
      ...props
    },
    ref
  ) => {
    return (
      <div className={cn(containerClassName)}>
        {label && (
          <div
            className={cn(
              "text-text-secondary font-medium text-responsive-sm",
              labelClassName
            )}
          >
            {label} {required && <span className="text-red-500">(*)</span>}
          </div>
        )}
        <input
          type={type}
          className={cn(
            "h-10 w-full rounded-sm border border-border-light bg-transparent px-3 py-2 text-responsive-base font-normal text-text-primary",
            "placeholder:text-text-secondary",
            "focus:outline-none focus:border-border-dark",
            "disabled:cursor-not-allowed disabled:opacity-50",
            error && "border-red-200",
            className
          )}
          ref={ref}
          {...props}
        />
        {error && <p className="text-sm text-red-400">{error}</p>}
      </div>
    );
  }
);
Input.displayName = "Input";
